import React, { useState, useEffect } from 'react';
import { Radio } from 'antd';
import KeywordRankingsView from './reportingtabs/KeywordRankingsView';
import TrafficView from './reportingtabs/TrafficView';
import LinkAcquisitionsView from './reportingtabs/LinkAcquisitionsView';
import ConversionsView from './reportingtabs/ConversionsView';
import ReferringDomainsView from './reportingtabs/ReferringDomainsView';
import { SEOTrafficProvider } from '../../../../../core/components/seoRefactored/seoDetails/context/SEOTrafficContext';
import { SEOLinkAcquisitionsProvider } from '../../../../../core/components/seoRefactored/seoDetails/context/SEOLinkAcquisitionsContext';
import { SEOConversionsProvider } from '../../../../../core/components/seoRefactored/seoDetails/context/SEOConversionsContext';
import { SEOKeywordsProvider } from '../../../../../core/components/seoRefactored/seoDetails/context/SEOKeywordsContext';
import { SEOReferringDomainsProvider } from '../../../../../core/components/seoRefactored/seoDetails/context/SEOReferringDomainsContext';

const ReportingTab = ({
  hasKeywordRankings,
  keywordsReportKey,
  trafficReportKey,
  conversionsReportKey,
  referralsReportKey,
  linkAcquisitionData,
  domain,
  setShowDatePicker,
  setSelectedDate,
  selectedDate,
  setSelectedDropdown,
  setReportData,
  setDeviceFilter,
  setCurrentTab,
}) => {
  const [selectedTab, setSelectedTab] = useState(hasKeywordRankings ? 'keywords' : 'traffic');

  useEffect(() => {
    //Show date picker for traffic and conversions
    if (
      selectedTab === 'link acquisitions' ||
      selectedTab === 'traffic' ||
      selectedTab === 'conversions' ||
      selectedTab === 'referring domains'
    )
      setShowDatePicker(true);
    else setShowDatePicker(false);

    //Reset selected date when tab changes
    //Link Aquisions does not have load time so no need to temporarily reset
    if (selectedTab !== 'link acquisitions') {
      setSelectedDate(null);
      setSelectedDropdown('Custom');
      setReportData([]);
    }
    if (setCurrentTab) {
      setCurrentTab(selectedTab);
    }
  }, [
    selectedTab,
    setReportData,
    setSelectedDate,
    setSelectedDropdown,
    setShowDatePicker,
    setCurrentTab,
  ]);
  return (
    <div>
      <Radio.Group
        value={selectedTab}
        onChange={(e) => setSelectedTab(e.target.value)}
        style={{ marginBottom: '20px' }}
      >
        {hasKeywordRankings ? <Radio.Button value="keywords">Keywords</Radio.Button> : null}
        <Radio.Button value="traffic">Traffic</Radio.Button>
        {/* Removed Link Acquisiotions */}
        {/* <Radio.Button value="link acquisitions">Link Acquisitions</Radio.Button>  */}
        <Radio.Button value="referring domains">Referring Domains</Radio.Button>
        <Radio.Button value="conversions">Conversions</Radio.Button>
      </Radio.Group>

      {selectedTab === 'keywords' && hasKeywordRankings ? (
        <SEOKeywordsProvider reportKey={keywordsReportKey}>
          <KeywordRankingsView setReportData={setReportData} setDeviceFilter={setDeviceFilter} />
        </SEOKeywordsProvider>
      ) : (
        <></>
      )}
      {selectedTab === 'traffic' && (
        <SEOTrafficProvider reportKey={trafficReportKey}>
          <TrafficView
            domain={domain}
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setReportData={setReportData}
          />
        </SEOTrafficProvider>
      )}
      {selectedTab === 'link acquisitions' && (
        <SEOLinkAcquisitionsProvider dataRaw={linkAcquisitionData}>
          <LinkAcquisitionsView
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setReportData={setReportData}
          />
        </SEOLinkAcquisitionsProvider>
      )}
      {selectedTab === 'referring domains' && (
        <SEOReferringDomainsProvider reportKey={referralsReportKey}>
          <ReferringDomainsView
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setReportData={setReportData}
          />
        </SEOReferringDomainsProvider>
      )}
      {selectedTab === 'conversions' && (
        <SEOConversionsProvider reportKey={conversionsReportKey}>
          <ConversionsView
            setSelectedDate={setSelectedDate}
            selectedDate={selectedDate}
            setReportData={setReportData}
          />
        </SEOConversionsProvider>
      )}
    </div>
  );
};

export default ReportingTab;
